// extracted by mini-css-extract-plugin
export default {"interactions":"TicketTable_interactions__23gNV","ticketTable":"TicketTable_ticketTable__DopkX"};